export interface MarketingItem {
  id: number;
  title: string;
  description: string;
  content: string;
  image: string;
  updateTime: string;
  views: number;
  features: string[];
}

export const marketingData: MarketingItem[] = [
  {
    id: 1,
    title: '受众画像分析平台发布',
    description: '受众画像分析平台整合多源数据，构建精准的用户画像体系。平台支持人口属性、兴趣爱好、消费行为、社交关系等200+维度标签，帮助广告主深入了解目标受众。',
    content: `受众画像分析平台是孔明智算广告中心的核心产品之一，旨在帮助广告主实现精准营销。平台通过整合多源数据，构建全面的用户画像体系，为广告投放提供数据支撑。

【核心功能】

1. 多维度标签体系
平台支持200+维度标签，包括：
- 人口属性：年龄、性别、地域、职业、收入等
- 兴趣爱好：阅读、游戏、购物、旅游等
- 消费行为：购买力、消费偏好、品牌忠诚度等
- 社交关系：社交影响力、社交圈层等

2. 实时画像更新
基于大数据流处理技术，用户画像实时更新，确保广告主掌握最新的受众动态。

3. 智能人群扩展
通过Lookalike算法，基于种子用户自动扩展相似人群，扩大目标受众覆盖面。

4. 画像洞察报告
提供可视化的画像分析报告，帮助广告主深入理解目标受众特征。

【应用案例】

某知名电商平台使用受众画像分析平台后，广告点击率提升45%，转化率提升30%，广告ROI提升120%。

【技术优势】

- 数据覆盖广：整合10亿+用户数据
- 标签精度高：标签准确率达95%以上
- 更新速度快：画像实时更新，延迟小于1秒
- 隐私保护好：严格遵守数据安全规范`,
    image: 'https://images.unsplash.com/photo-1533750349088-cd871a92f312?w=800&h=500&fit=crop',
    updateTime: '2024-03-15 16:00',
    views: 4521,
    features: ['200+维度标签', '实时画像更新', '智能人群扩展', '可视化报告'],
  },
  {
    id: 2,
    title: '跨平台投放管理系统',
    description: '一站式跨平台投放管理系统，支持主流广告平台的统一管理和优化。系统提供可视化的投放界面，支持批量创建、编辑广告计划，实时监控投放效果。',
    content: `跨平台投放管理系统是孔明智算为广告主打造的一站式广告投放解决方案。系统整合了主流广告平台，实现统一管理和智能优化。

【支持平台】

- 搜索引擎广告：百度推广、360推广、搜狗推广
- 信息流广告：今日头条、腾讯广告、百度信息流
- 社交媒体广告：微信朋友圈、微博粉丝通、抖音广告
- 电商平台广告：淘宝直通车、京东快车、拼多多推广

【核心功能】

1. 统一账户管理
一个后台管理多个平台账户，无需频繁切换，提升工作效率。

2. 批量操作
支持跨平台批量创建、编辑、暂停广告计划，大幅减少重复工作。

3. 智能出价
基于机器学习算法，自动优化出价策略，以最低成本获取最优流量。

4. 效果监控
实时监控各平台投放效果，统一数据报表，便于对比分析。

5. 预算分配
智能分配各平台预算，确保整体ROI最大化。

【客户收益】

使用跨平台投放管理系统的客户平均节省50%的操作时间，广告效果提升35%。`,
    image: 'https://images.unsplash.com/photo-1432888498266-38ffec3eaf0a?w=800&h=500&fit=crop',
    updateTime: '2024-03-14 11:30',
    views: 3876,
    features: ['多平台整合', '批量操作', '智能出价', '统一报表'],
  },
  {
    id: 3,
    title: '实时效果监测仪表盘',
    description: '实时效果监测仪表盘提供全方位的广告数据可视化分析。支持曝光量、点击率、转化率、ROI等核心指标的实时监控，多维度下钻分析帮助快速定位问题。',
    content: `实时效果监测仪表盘是广告主的"作战指挥室"，提供全方位的广告数据可视化分析，帮助广告主实时掌握投放效果，快速做出决策。

【监控指标】

1. 基础指标
- 曝光量：广告展示次数
- 点击量：用户点击次数
- 点击率：点击/曝光比率
- 花费：广告投放成本

2. 转化指标
- 转化量：完成目标行为的次数
- 转化率：转化/点击比率
- 转化成本：花费/转化量
- ROI：投入产出比

3. 用户指标
- 触达人数：独立用户曝光数
- 频次：人均曝光次数
- 覆盖人群：目标受众覆盖度

【分析维度】

- 时间维度：小时、天、周、月趋势分析
- 地域维度：省份、城市效果对比
- 设备维度：PC、移动端效果分析
- 创意维度：各创意效果对比

【特色功能】

1. 异常预警
系统自动检测数据异常，及时预警，避免损失。

2. 智能诊断
基于AI算法，自动诊断投放问题，给出优化建议。

3. 竞品监控
监控竞品广告动态，了解市场竞争态势。

4. 自定义报表
支持自定义报表模板，定时自动发送。`,
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=500&fit=crop',
    updateTime: '2024-03-13 14:15',
    views: 2987,
    features: ['实时监控', '多维度分析', '异常预警', '智能诊断'],
  },
  {
    id: 4,
    title: '智能预算优化工具',
    description: '智能预算优化工具基于预测模型，自动调整广告预算分配。系统分析历史投放数据，预测各渠道、各时段的转化效果，动态优化预算分配策略。',
    content: `智能预算优化工具运用先进的机器学习算法，帮助广告主实现预算的最优分配，在有限预算内获得最大的广告效果。

【优化策略】

1. 渠道优化
根据各渠道的历史表现和实时数据，动态调整各渠道的预算分配比例。

2. 时段优化
分析不同时段的转化效果，在高效时段增加预算，低效时段减少预算。

3. 人群优化
识别高价值人群，增加对高价值人群的预算投入。

4. 创意优化
根据各创意的表现，自动调整创意预算分配。

【核心算法】

1. 效果预测模型
基于历史数据，预测不同预算分配方案的效果。

2. 预算分配算法
使用强化学习算法，自动寻找最优预算分配策略。

3. 实时调整机制
根据实时数据反馈，快速调整预算分配。

【应用效果】

实际应用显示，使用智能预算优化工具的客户，在相同预算下转化量平均提升30%，ROI提升50%。

【适用场景】

- 预算有限，希望获得最大效果
- 多渠道投放，需要优化预算分配
- 季节性营销，需要动态调整预算
- 新品推广，需要快速测试优化`,
    image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&h=500&fit=crop',
    updateTime: '2024-03-12 10:00',
    views: 2156,
    features: ['渠道优化', '时段优化', '人群优化', '实时调整'],
  },
  {
    id: 5,
    title: '创意素材智能推荐',
    description: '创意素材智能推荐系统分析历史广告数据，识别高绩效创意特征，为新广告创作提供数据指导。系统支持图片、视频、文案等多种素材类型的效果预测。',
    content: `创意素材智能推荐系统是广告主的"创意助手"，通过分析海量历史数据，为广告创意提供数据驱动的优化建议。

【分析维度】

1. 图片创意
- 色彩分析：主色调、色彩饱和度
- 构图分析：主体位置、画面布局
- 元素分析：人物、产品、场景等元素
- 文字分析：文案内容、字体、位置

2. 视频创意
- 时长分析：最佳视频长度
- 节奏分析：画面切换频率
- 开头分析：前3秒吸引力
- 音乐分析：背景音乐效果

3. 文案创意
- 标题分析：点击率最高的标题类型
- 正文分析：转化率最优的文案结构
- CTA分析：最有效的行动号召

【推荐功能】

1. 创意灵感
基于行业热门创意，提供创意灵感参考。

2. 效果预测
上传创意素材，系统预测投放效果。

3. 优化建议
针对现有创意，提供具体的优化建议。

4. A/B测试
自动设计A/B测试方案，验证创意效果。

【客户收益】

使用创意素材智能推荐系统的客户，创意测试成本降低40%，优质创意产出效率提升60%。`,
    image: 'https://images.unsplash.com/photo-1542744094-3a31f272c490?w=800&h=500&fit=crop',
    updateTime: '2024-03-11 16:30',
    views: 1876,
    features: ['多维度分析', '效果预测', '优化建议', 'A/B测试'],
  },
  {
    id: 6,
    title: '程序化广告投放引擎',
    description: '程序化广告投放引擎支持RTB实时竞价，毫秒级响应广告请求。引擎整合多家DSP和SSP资源，通过智能算法优化出价策略，以最优价格获取目标流量。',
    content: `程序化广告投放引擎是孔明智算的核心技术产品，采用先进的RTB技术，实现广告的精准投放和智能优化。

【技术架构】

1. 实时竞价系统
毫秒级响应广告请求，支持每秒百万级QPS。

2. 智能出价算法
基于用户价值和竞争情况，实时计算最优出价。

3. 用户识别系统
跨设备、跨平台识别用户，实现精准定向。

4. 反作弊系统
实时识别和过滤作弊流量，保障广告效果。

【核心能力】

1. 精准定向
支持人群包、Lookalike、重定向等多种定向方式。

2. 频次控制
智能控制广告曝光频次，避免过度曝光。

3. 品牌安全
自动过滤敏感内容，保护品牌形象。

4.  viewability优化
优化广告可见度，提升有效曝光。

【对接资源】

- 头部DSP：百度DSP、腾讯DSP、阿里妈妈等
- 主流SSP：百度SSP、腾讯广告联盟、穿山甲等
- Ad Exchange：百度EX、腾讯EX、阿里EX等

【应用效果】

使用程序化广告投放引擎的客户，平均降低获客成本25%，提升转化效果40%。`,
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=500&fit=crop',
    updateTime: '2024-03-10 13:45',
    views: 2345,
    features: ['RTB竞价', '智能出价', '精准定向', '品牌安全'],
  },
  {
    id: 7,
    title: '广告归因分析模型',
    description: '多触点广告归因分析模型，科学评估各渠道对转化的贡献。支持首次点击、末次点击、线性、时间衰减等多种归因模型，帮助广告主全面了解用户转化路径。',
    content: `广告归因分析模型帮助广告主科学评估各广告渠道对转化的贡献，解决"广告效果归谁"的难题。

【归因模型】

1. 首次点击归因
将转化功劳归于用户第一次点击的广告。

2. 末次点击归因
将转化功劳归于用户最后一次点击的广告。

3. 线性归因
将转化功劳平均分配给转化路径上的所有触点。

4. 时间衰减归因
越接近转化的触点，分配越多的功劳。

5. 位置归因
首次和末次点击获得较多功劳，中间点击平均分配。

6. 数据驱动归因
基于算法，根据实际数据计算各触点的贡献度。

【分析能力】

1. 转化路径分析
展示用户从首次接触到最终转化的完整路径。

2. 辅助转化分析
识别在转化过程中起辅助作用的渠道。

3. 最终转化分析
识别直接导致转化的渠道。

4. 跨设备归因
支持跨设备的转化归因分析。

【应用价值】

- 科学分配预算：了解各渠道真实贡献，合理分配预算
- 优化投放策略：识别高效渠道，优化投放组合
- 评估新渠道：科学评估新渠道的增量价值
- 避免重复计算：防止多渠道重复计算转化`,
    image: 'https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?w=800&h=500&fit=crop',
    updateTime: '2024-03-09 09:30',
    views: 1654,
    features: ['多归因模型', '转化路径', '跨设备归因', '数据驱动'],
  },
  {
    id: 8,
    title: '品牌安全监测系统',
    description: '品牌安全监测系统实时扫描广告投放环境，确保品牌形象不受损害。系统采用NLP和图像识别技术，自动识别敏感内容、负面舆情，及时预警并暂停相关投放。',
    content: `品牌安全监测系统是广告主的品牌"保镖"，24小时守护品牌形象，确保广告投放环境的安全。

【监测能力】

1. 内容安全监测
- 暴力恐怖内容识别
- 色情低俗内容识别
- 违法违规内容识别
- 虚假欺诈内容识别

2. 舆情风险监测
- 负面新闻关联
- 舆情危机预警
- 竞品恶意攻击
- 用户负面评价

3. 广告环境评估
- 页面质量评分
- 广告位可见度
- 流量真实性
- 品牌适配度

【技术手段】

1. NLP文本分析
自然语言处理技术，识别文本中的风险内容。

2. 图像识别
计算机视觉技术，识别图片、视频中的风险元素。

3. 知识图谱
构建风险内容知识图谱，提升识别准确率。

4. 实时预警
风险内容实时预警，毫秒级响应。

【防护措施】

1. 投放前审核
广告上线前进行品牌安全审核。

2. 投放中监测
7x24小时实时监测投放环境。

3. 风险自动处置
发现风险自动暂停投放，避免损失扩大。

4. 白名单机制
建立优质媒体白名单，优先投放。

【服务承诺】

- 风险识别率>99%
- 预警响应时间<100ms
- 误报率<1%`,
    image: 'https://images.unsplash.com/photo-1563986768609-322da13575f7?w=800&h=500&fit=crop',
    updateTime: '2024-03-08 15:00',
    views: 1987,
    features: ['内容安全', '舆情监测', '实时预警', '自动处置'],
  },
];
